/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:19/08/2020
 @Time:07:34
 **/

/**
 * liste des actions disponibles ajax sont actionPrform , getForm ,submitForm
 * action-perform: une requette sera exécuté de la part du l'application avec une une eventuelle résultat a returner (json code , html message ....etc)
 * form: une formulaire sera récupéré coté serveur ,rempli de la part de l'utilisateur et re-envoyé de nouveau serveur
 */
(function ($) {
    $.fn.begroAjax = function (options) {
        // This is the easiest way to have default options.
        var settings = $.extend({
            // These are the defaults.
            event: "click",//l'évènement qui va déclencher le traitement ajax
            ajaxAction: "action-perform",
            ajaxURL: null,//url demandé
            successOrFailureMessageFeedbackFromResponseBody: false,// le message de feedback de l'execution de l'action sera retiré de corps de la dernière réponse http
            confirmDialog: false,//afficher une fênetre de confirmation pour les requette ajax  de type action-perform
            confirmationMessage: null,//le message de confirmation qui sera affiché a l'utilisateur
            onCancelCallback: function () {
            },//le traitement a effectué si l'utilisateur clique sur annuler
            onConfirmCallback: function () {
                return true;
            },//cette fonction sera appelé si l'utilisateur confirme l'action. Note :si la fonction retourne true l'appel ajax sera effectué sinon la boite se disparaitre avec l'appel de la fonction onCancelCallback
            confirmButtonText: "confirm",//le texte du bouton confirmer// sera utilisé si confirm dialog existe
            cancelButtonText: "cancel",//le texte du bouton annuler//sera utilisé si confirm dialog existe
            confirmFormSubmitButtonText: "Submit",//le texte du bouton enregister la formuliare
            cancelFormButtonText: "cancel",//le texte du bouton annuler//sera utilisé pour la soumission de la formulaire
            formDialogTitle:null,//le titre de la boite de dialog contenant la formulmaire
            method: "GET",//méthode de la requette ajax qui sera lancé //si ajax request est associé a une formulaire ,ce paramètre sera ignoré  methode get est utilisé pour récupération de la formulaire et post pour le submit
            data: {}, //les données qui seront envoyés dans le cas ou l'action ajax demandé est de type action-perform
            successAjaxCallback: function (data,originalSource) {
            },//fonction qui sera appelé si code retour de l'éxécution de la requette ajax est 200 => originalSource l'élement HTML (bouto ,select ...) origine de ctraitement ajax
            failureAjaxCallback: function (data,originalSource) {
            },//fonction qui sera appelé si code retour de l'éxécution de la requette ajax est 500(erreur)=> originalSource l'élement HTML (bouto ,select ...) origine de ctraitement ajax
        }, options);
        //
        let attacherTraitement=function () {
            let originalSource = $(this);// l'element HTMl bouton , select l'origine de ce traitement ajax
            //afficher le message de traitement que ce soit erreur ou succées
            let feedbackNotice = function (success, message) {
                let jbox = new jBox('Notice', {
                    content: message,
                    color: success ? 'green' : 'red',
                    theme: jBoxNoticeTheme
                });
                jbox.open();

            }
            //ajax request qui permet d'exécuter action perform et afficher un feedback message et executer
            let createNewFormBox = function (formContent) {
                return new jBox('Confirm', {
                    confirmButton: settings.confirmFormSubmitButtonText,
                    cancelButton: settings.cancelFormButtonText,
                    content: formContent,
                    title: settings.formDialogTitle,
                    addClass: "begro-jbox-form",
                    confirm: function () {
                        $.ajax({
                            method: "POST",
                            url: typeof settings.ajaxURL === "function" ? settings.ajaxURL(originalSource) : settings.ajaxURL,
                            data: formContent.serialize(),
                            complete: function (jqXHR, status) {
                                let contentType = jqXHR.getResponseHeader("Content-type");
                                if (status === "success" && contentType.split(';')[0] === "application/json") {
                                    let responseData = JSON.parse(jqXHR.responseText);
                                    settings.successAjaxCallback(responseData.data, originalSource);
                                    if (settings.successOrFailureMessageFeedbackFromResponseBody) {
                                        feedbackNotice(true, responseData.feedbackMessage);
                                    }
                                } else {//pour toute autre type de réponse différent de texte
                                    createNewFormBox($(jqXHR.responseText)).open();// recréer jbox confirm avec la formulaire erroné contenant des éventuelles erreur
                                }
                            }
                        })
                    }
                });
            }
            let executeAjaxAction = function (settings, confirmationDialog) {
                $.ajax({
                    method: (settings.ajaxAction === "action-perform") ? settings.method : "GET",
                    url: typeof settings.ajaxURL === "function" ? settings.ajaxURL(originalSource) : settings.ajaxURL,
                    success: function (data) {
                        if (settings.ajaxAction === "action-perform") {
                            settings.successAjaxCallback(data, originalSource);
                            if (settings.successOrFailureMessageFeedbackFromResponseBody) {
                                if (settings.successOrFailureMessageFeedbackFromResponseBody) {
                                    feedbackNotice(true, data);
                                }
                            }
                        } else {
                            //si elle existe une boite de dialog de confirmation avant d'afficher boite de dialogue pour une formulaire on le supprime et on affiche la boite de dialogue pour remplir formulaire
                            if (confirmationDialog !== null) {
                                confirmationDialog.close();
                                confirmationDialog.destroy();
                            }
                            createNewFormBox($(data)).open();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        settings.failureAjaxCallback(xhr.responseText, originalSource);
                        let responseBody = xhr.responseText;
                        feedbackNotice(false, responseBody !== "" ? responseBody : thrownError);
                    }
                });
            };
            if (settings.confirmDialog) {
                let confirmationBox = new jBox('Confirm', {
                    confirmButton: settings.confirmButtonText,
                    cancelButton: settings.cancelButtonText,
                    content: settings.confirmationMessage,
                    addClass: "begro-jbox-confirmation",
                    confirm: function () {
                        let launchAjaxRequest = settings.onConfirmCallback();//appel de la fonction suite a la confirmation de l'action
                        if (launchAjaxRequest) {
                            executeAjaxAction(settings, confirmationBox);
                        }
                    }, cancel: function () {
                        settings.onCancelCallback();
                    }
                });
                confirmationBox.open();
            } else {
                executeAjaxAction(settings, null);
            }
            return false;
        };
        this.on(settings.event,attacherTraitement);
    };
}(jQuery));